/** TipTap throws if `editor.view` is accessed before the EditorView exists (proxy stubs omit `dom`). */
export function getSafeEditorDom(editor) {
  if (!editor || editor.isDestroyed) return null
  try {
    const dom = editor.view.dom
    return dom instanceof HTMLElement ? dom : null
  } catch {
    return null
  }
}
